import { PropsWithChildren, type ReactElement } from 'react';

import { Box } from '../Box';

import { Title } from './components/Title';
import { Subtitle } from './components/Subtitle';

export type PageHeaderComponent = ((
  props: PropsWithChildren
) => ReactElement) & {
  Title: typeof Title;
  Subtitle: typeof Subtitle;
};

export const PageHeader: PageHeaderComponent = ({ children }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'nowrap',
      justifyContent: 'center',
      gap: '8px',
    }}
  >
    {children}
  </Box>
);

PageHeader.Title = Title;
PageHeader.Subtitle = Subtitle;
